var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClientSource(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.6667 12.9167H16.25V3.25H26.9833C33.05 3.25 36.6667 6.86667 36.6667 12.9167Z",
    fill: "#8E99A7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6667 27.0833C36.5833 33.0333 32.9833 36.5833 26.9833 36.5833H16.25V27.0833H36.6667Z",
    fill: "#8E99A7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7497 3.25V36.5833H13.0163C6.94967 36.5833 3.33301 32.9667 3.33301 26.9V12.9333C3.33301 6.86667 6.94967 3.25 13.0163 3.25H13.7497Z",
    fill: "#8E99A7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6667 15.4167H16.25V24.5834H36.6667V15.4167Z",
    fill: "#8E99A7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClientSource);
export default __webpack_public_path__ + "static/media/client-source.dd10086ec5864035e1db2cdffad82165.svg";
export { ForwardRef as ReactComponent };